<div class="page-content">
  <!-- ── PAGE HEADER ─────────────────────────────────────────── -->
  <div class="page_header">
    <div class="page_header_text">
      <h1>Registos de Atividade</h1>
      <span>Histórico de auditoria e logs de alterações no sistema</span>
    </div>

    <div class="page_header_actions">
      <!-- Search Input -->
      <div class="search-input-wrapper">
        <i class="ri-search-line search-icon"></i>
        <input type="text" class="search-input" placeholder="Pesquisar por nome ou e-mail..." [ngModel]="searchTerm"
          (ngModelChange)="onSearch($event)" />
        <button *ngIf="searchTerm" class="clear-search-btn" (click)="onSearch('')" title="Limpar pesquisa">
          <i class="ri-close-line"></i>
        </button>
      </div>

      <!-- Filter Toggle Button -->
      <button class="btn-web-secondary" (click)="filtrosPainelAberto = true">
        <i class="ri-filter-3-line"></i> Filtros
        <span class="badge-count" *ngIf="activeFilterCount > 0">
          {{ activeFilterCount }}
        </span>
      </button>

      <!-- Clear Filters Button (If active) -->
      <button *ngIf="activeFilterCount > 0 || searchTerm" class="btn-web-secondary text-danger"
        (click)="limparFiltros()" title="Resetar todos os filtros">
        <i class="ri-refresh-line"></i> Limpar
      </button>
    </div>
  </div>

  <!-- ── ACTIVE FILTERS CHIPS ───────────────────────────────── -->
  <div class="filter-chips-row" *ngIf="filtroChips.length > 0">
    <span class="chips-label"><i class="ri-filter-fill"></i> Filtros Ativos:</span>
    <div class="chip" *ngFor="let chip of filtroChips">
      <span>{{ chip.label }}</span>
      <button (click)="removerFiltro(chip.key)">
        <i class="ri-close-line"></i>
      </button>
    </div>
    <button class="btn-link-clear" (click)="limparFiltros()">Limpar todos</button>
  </div>

  <!-- ── DATA TABLE WRAPPER ─────────────────────────────────── -->
  <div class="data-table-wrapper">
    <table class="data-table" *ngIf="!loading && logs.length > 0">
      <thead>
        <tr>
          <th>Data / Hora</th>
          <th>Utilizador</th>
          <th>Ação</th>
          <th>Entidade</th>
          <th>Campo Alterado</th>
          <th>Valor Anterior</th>
          <th>Valor Novo</th>
          <th>Estado</th>
          <th class="text-right">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let log of logs; trackBy: trackByLogId">
          <td class="date-col">
            <i class="ri-time-line text-muted"></i>
            {{ log.dataCriacaoFormatada || (log.dataCriacao | date:'dd/MM/yyyy HH:mm') }}
          </td>
          <td>
            <div class="user-cell">
              <span class="user-name">{{ log.nome || 'Desconhecido' }}</span>
              <small class="user-email text-muted">{{ log.email || log.username || 'Desconhecido' }}</small>
            </div>
          </td>
          <td>
            <span class="badge" [ngClass]="getAcaoClass(log.acaoLogsEnum, log.acaoLogs)">
              <i [class]="getAcaoIcon(log.acaoLogsEnum, log.acaoLogs)"></i>
              {{ log.acaoLogs || 'Desconhecido' }}
            </span>
          </td>
          <td>
            <span class="entity-tag">
              <i class="ri-database-2-line"></i> {{ log.entidade }}
            </span>
          </td>
          <td class="field-col">
            <span class="field-name">{{ log.campoAlterado || 'Registo modificado' }}</span>
          </td>
          <td class="val-col">
            <span class="old-val" [pTooltip]="log.valorAnterior" tooltipPosition="top">
              {{ log.valorAnterior || '-' }}
            </span>
          </td>
          <td class="val-col">
            <span class="new-val" [pTooltip]="log.valorNovo" tooltipPosition="top">
              {{ log.valorNovo || '-' }}
            </span>
          </td>
          <td>
            <span class="status-dot" [ngClass]="log.sucesso ? 'success' : 'danger'">
              <i [class]="log.sucesso ? 'ri-checkbox-circle-line' : 'ri-close-circle-line'"></i>
              {{ log.sucesso ? 'Sucesso' : 'Falha' }}
            </span>
          </td>
          <td class="actions-cell text-right">
            <button class="btn-icon-action" (click)="verDetalhes(log)" pTooltip="Ver Detalhes" tooltipPosition="left">
              <i class="ri-eye-line"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- EMPTY STATE -->
    <app-empty-state *ngIf="!loading && logs.length === 0" icon="ri-history-line"
      title="Nenhum registo de atividade encontrado"></app-empty-state>

    <!-- SKELETON LOADER -->
    <div *ngIf="loading" class="skeleton-rows">
      <div *ngFor="let i of [1, 2, 3, 4, 5]" class="skeleton-row-item">
        <p-skeleton height="42px" styleClass="mb-2"></p-skeleton>
      </div>
    </div>

    <!-- PAGINATOR -->
    <p-paginator *ngIf="totalRecords > pageSize" [rows]="pageSize" [totalRecords]="totalRecords"
      [first]="(pageNumber - 1) * pageSize" [rowsPerPageOptions]="[10, 20, 50, 100]"
      (onPageChange)="onPageChange($event)" styleClass="sp-paginator"></p-paginator>
  </div>
</div>

<!-- ── FILTROS DRAWER / OVERLAY ───────────────────────────── -->
<div class="filtros-overlay" [class.open]="filtrosPainelAberto" (click)="filtrosPainelAberto = false"></div>

<div class="filtros-drawer" [class.open]="filtrosPainelAberto">
  <div class="filtros-header">
    <h3 class="fd-title">
      <i class="ri-equalizer-3-line"></i> Filtros de Registos
    </h3>
    <button type="button" class="filtros-close-btn" (click)="filtrosPainelAberto = false">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="filtros-body" [formGroup]="filtrosForm">
    <!-- Nome -->
    <div class="filtro-grupo">
      <label>Nome do Utilizador</label>
      <input type="text" formControlName="Nome" class="form-input" placeholder="Nome do utilizador" />
    </div>

    <!-- Email -->
    <div class="filtro-grupo">
      <label>E-mail</label>
      <input type="email" formControlName="Email" class="form-input" placeholder="Email do utilizador" />
    </div>

    <!-- AcaoLogsEnum -->
    <div class="filtro-grupo">
      <label>Ação (AcaoLogsEnum)</label>
      <p-select formControlName="AcaoLogsEnum" [options]="acaoOptions" optionLabel="label" optionValue="value"
        placeholder="Selecione a ação" styleClass="w-full" appendTo="body" [showClear]="true"></p-select>
    </div>

    <!-- EntidadeENUM -->
    <div class="filtro-grupo">
      <label>Entidade (EntidadeENUM)</label>
      <p-select formControlName="EntidadeENUM" [options]="entidadeOptions" optionLabel="label" optionValue="value"
        placeholder="Selecione a entidade" styleClass="w-full" appendTo="body" [showClear]="true"></p-select>
    </div>

    <!-- DataHora (seleciona apenas a data; envia DataInicio/DataFim do dia inteiro) -->
    <div class="filtro-grupo">
      <label>Data/Hora</label>
      <p-date-picker formControlName="DataHora" dateFormat="dd/mm/yy" placeholder="Selecione a data" styleClass="w-full"
        appendTo="body" [showClear]="true"></p-date-picker>
    </div>
  </div>

  <div class="filtros-footer">
    <button type="button" class="btn-web-secondary" style="flex: 1" (click)="$event.preventDefault(); $event.stopPropagation(); limparFiltrosDrawer()">
      <i class="fas fa-undo"></i> Limpar
    </button>
    <button type="button" class="btn-web-primary" style="flex: 2" (click)="aplicarFiltrosDrawer()">
      <i class="fas fa-check"></i> Aplicar
    </button>
  </div>
</div>

<!-- ── LOG DETAILS DRAWER COMPONENT ────────────────────────── -->
<app-detalhe-registo-drawer [(visible)]="mostrarDetalheDrawer" [log]="selectedLog"></app-detalhe-registo-drawer>
